import * as Yup from "yup";

export const createSchema = Yup.object().shape({
  FirstName: Yup.string().required("First name is required"),
  Email: Yup.string()
    .required("Email is required")
    .email(),
  Group: Yup.string().required("You must select a group")
});

export const editSchema = Yup.object().shape({
  FirstName: Yup.string().required("First name is required"),
  Email: Yup.string()
    .required("Email is required")
    .email(),
  Password: Yup.string().matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
    "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
  ),
  ConfirmPassword: Yup.string().when("Password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: () =>
      Yup.string().oneOf(
        [Yup.ref("Password")],
        "Both password need to be the same"
      ),
  }),
  Group: Yup.string().required("You must select a group"),
});
